import { useAuth } from "@/contexts/AuthContext";
import { createFileRoute, Navigate } from "@tanstack/react-router";

export const Route = createFileRoute("/")({
  component: RouteComponent,
});

function RouteComponent() {
  const { loading, userProfile, profileLoading } = useAuth();

  if (loading || profileLoading) {
    return (
      <div className="flex min-h-screen items-center justify-center">
        <div className="text-center">
          <div className="mx-auto mb-4 h-8 w-8 animate-spin rounded-full border-b-2 border-gray-900"></div>
          <p className="text-gray-600">Loading ...</p>
        </div>
      </div>
    );
  }

  let dashboarRoute: string | null = null;

  if (userProfile) {
    if (userProfile.type === "admin") {
      dashboarRoute = "/dashboard/admin";
    } else if (userProfile.type === "customer") {
      dashboarRoute = "/dashboard/customer";
    } else if (userProfile.type === "manager") {
      dashboarRoute = "/dashboard/admin";
    }
  }

  if (loading || profileLoading) {
    return (
      <div className="flex min-h-screen items-center justify-center">
        <div className="text-center">
          <div className="mx-auto mb-4 h-8 w-8 animate-spin rounded-full border-b-2 border-gray-900"></div>
          <p className="text-gray-600">Loading ...</p>
        </div>
      </div>
    );
  }

  return (
    <div className="flex min-h-screen items-center justify-center">
      {dashboarRoute !== null ? <Navigate to={dashboarRoute} /> : <Navigate to={"/login"} />}
    </div>
  );
}
